<template>
    <!-- Hide header if Portal is being displayed in an Iframe -->
    <div id="divHeaderContent" class="row pad-10" v-if="!this.$store.getters.getRenderPagesInIframe">
        <div class="col-md-7 col-sm-12 col-xs-12 header-img"><img :src="headerData.HeaderImage" alt="Logo" /></div>
        <div id="divCustomerAccountInformation" class="col-md-5 col-sm-12 col-xs-12" v-if="headerData != null" :class="showSmallerScreenAccountInformation">
            <div v-show="headerData.DisplayHeaderAccountInformation" class="header-account panel panel-primary">
                <!-- Display Header information only if the RepSetting is turned on for it -->        
                <div class="row padding-bottom-25 account-close" v-show="openAccountInformation">
                    <div class="col-xs-2 col-xs-offset-10">
                        <a href="#" @click.prevent="resetShowHeaderAccountInformation()"><v-icon name="times" class="icon-2x" /></a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-12">
                        <!-- Customer Name -->
                        <div class="pad-bottom-5">
                            <label class="lbl">{{ $t("message.welcome") }} {{headerData.CustomerFullName }}</label>
                        </div> 
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-6">  
                        <!-- Account Number -->
                        <div id="divAccountNumber" class="pad-bottom-5">
                            <label for="ddlSelectedAccount" class="lbl">{{ $t("message.account") }}</label><br />
                            <div v-if="headerData.DisplayAccountsDropdown">
                                <select id="ddlSelectedAccount" v-model="headerData.SelectedAccount" class="form-control" @change="selectNewAccount(headerData.SelectedAccount)">
                                    <option v-for="option in headerData.CustomerAvailableAccounts" 
                                            :key="option.CustomerAccountInfoID" :value="option">{{option.UtilityAccountNumber}}</option>
                                </select> 
                            </div>
                            <div v-else>
                                <label>{{ headerData.AccountNumber }}</label>
                            </div>                            
                        </div>                        

                        <!-- Service Location -->
                        <div id="divServiceLocation">
                            <label for="ddlSelectedServiceLocation" class="lbl">{{ $t("message.serviceLocation") }}</label><br />
                            <div v-if="headerData.DisplayServiceLocationDropdown">
                                <select id="ddlSelectedServiceLocation" v-model="headerData.SelectedServiceLocation" class="form-control" @change="selectNewServiceLocation(headerData.SelectedServiceLocation)">
                                    <option v-for="option in headerData.CustomerAvailableServiceLocations" 
                                            :key="option.ServiceLocationID" :value="option">{{ option.Address1 }}</option>
                                </select>
                            </div>
                            <div v-else>
                                {{ headerData.SelectedServiceLocationAddress }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-6 text-center pad-10-override">
                        <!-- Billing Information (Prepay or Postpay) -->
                        <div v-if="headerData.IsPrePay">
                            <div class="pad-bottom-5">
                                <label for="lblDaysRemaining" class="lbl">{{ $t("message.daysRemaining") }}</label><br />
                                <label id="lblDaysRemaining" class="lbl badge" :style="{color: headerData.HeaderBalanceData.DaysRemainingColor, 'background-color': headerData.HeaderBalanceData.DaysRemainingBackgroundColor}">
                                    {{ headerData.HeaderBalanceData.DaysRemaining }}
                                </label>
                            </div>
                            <div>
                                <label for="lblDollarsRemaining" class="lbl">{{ $t("message.dollarsRemaining") }}</label><br />
                                <label id="lblDollarsRemaining" class="lbl" :style="{color: headerData.HeaderBalanceData.DollarsRemainingNegativeColor}">
                                    {{ handleNegativeNumber($n(headerData.HeaderBalanceData.DollarsRemaining, 'currency')) }}
                                </label>
                            </div>
                        </div>
                        <div v-else>
                            <div class="pad-bottom-5">
                                <label for="lblDaysInBillingPeriod" class="lbl">{{ $t("message.daysInBillingPeriod") }}</label><br /><label id="lblDaysInBillingPeriod" class="lbl">{{ headerData.DaysInBillingPeriod }}</label>
                            </div>
                            <div>
                                <label for="lblTotalDue" class="lbl">{{ headerData.TotalDueLabelText }}</label><br /><label id="lblTotalDue" class="lbl">{{ headerData.TotalDue }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>    
    </div>
</template>

<script>
import axios from "axios";
import commonJs from '@/common.js';

export default {
    name: 'Header',
    data() {
        return {
            openAccountInformation: false      
        }
    },
    mounted() {
        this.resetShowHeaderAccountInformation();
    },
    methods: {
        resetShowHeaderAccountInformation() {
            this.openAccountInformation = false;
            this.$store.commit('setShowHeaderAccountInformation', false); 
        },
        selectNewServiceLocation(selectedSL) {
            if (selectedSL.ServiceLocationID > 0) {
                // If we get a valid Service Location Id, we will need to reset our Session data 
                // so we can get all new data based on this new Service Location selected
                axios({
                    method: "POST",
                    url: this.$httpAxiosBaseUrl() + "Home/UpdateCustomerSelectedServiceLocation",
                    data: {
                        selectedServiceLocation: selectedSL
                    }
                }).then(result => {
                    var response = result.data;
                    if (response) {
                        // Successful in updating Session data, lets reload the app so we get all the latest values
                        window.location.reload(true);
                    } else {
                        this.displayError("An error occurred while trying to switch between Service Locations");                        
                    }
                }, error => {
                    console.log(error);
                });
            }
        },
        selectNewAccount(selectedAccount) {
            if (selectedAccount.CustomerAccountInfoID > 0) {
                // If we get a valid Customer Account, we will need to reset our Session data
                // so we can get all new data based on this new Account
                axios({
                    method: "POST",
                    url: this.$httpAxiosBaseUrl() + "Home/UpdateCustomerSelectedAccount",
                    data: {
                        selectedAccount: selectedAccount
                    }
                }).then(result => {
                    var response = result.data;
                    if (response) {
                        // Successful in updating Session data, let's reload the app so we get all the latest values
                        window.location.reload(true);
                    } else {
                        this.displayError("An error occurred while trying to switch between Accounts");
                    }
                }, error => {
                    console.log(error);
                });
            }
        },
        handleNegativeNumber(num) {
            return commonJs.reformatNumber(num);
        },
        displayError(message) {
            this.$toasted.global.error(message);
            this.$announcer.set(message);
        }
    },
    computed: {
        headerData() {
            return this.$store.getters.getCustomerInfo;
        },
        showSmallerScreenAccountInformation() {
            var isDesktop = this.$store.getters.getIsDesktop;
            if (!isDesktop) {
                // Smaller screens
                if (this.$store.getters.getShowHeaderAccountInformation) {
                    this.openAccountInformation = true;
                    return 'customer-account-information';
                } else {
                    this.openAccountInformation = false;
                    return 'hide';
                }
            } else {
                // Larger screens
                this.resetShowHeaderAccountInformation();
                return '';
            }
        },
    }
}
</script>

<style scoped>
#divHeaderContent {
    display: flex;
    align-items: center;
    justify-content: center;
}

.account-close a {
    color: #000;
}
</style>

